/**
 * @deprecated This hook is deprecated. Use the UserProfileProvider context instead.
 * Import from '@/components/providers/UserProfileProvider'
 *
 * This file is kept for backward compatibility but will be removed in a future version.
 */

export { useUserProfile } from '@/components/providers/UserProfileProvider'